import React from "react";

// import MaterialUiPhoneNumber from 'material-ui-phone-number';

import PhoneNumberInput from "../PhoneNumber/PhoneNumberInput";

import { CustomTextInput } from "./_helpers/CustomTextInput";
import { useOwnerCompanyDataContext } from "../../contexts/OwnerCompanyDataProvider";

// const isValid = (inputNumber) => {
//     return true;
// }

const validatePhone = (inputNumber, allValues) => {
	if (!inputNumber) return;
	inputNumber = inputNumber.replace(/\D/g, "");
	// to many countries
	// TODO: gat coutry data from MaterialUiPhoneNumber
	// for (const key in dataValidation) {
	//     if (inputNumber.startsWith(dataValidation[key].dialCode)){
	//         let data = dataValidation[key];
	//         if (inputNumber.length != data.length){
	//             return { message: 'Phone number for this country must contains %{length} digits.', args: { length: data.length } };
	//         } else {
	//             return;
	//         }
	//     }
	// }
	if (inputNumber.length < 8 || inputNumber.length > 12) {
		return { message: "Phone number must contains %{length} digits.", args: { length: "[8-12]" } };
	}
	return;
};


export const PhoneInputBase = ({ defaultCountry = "no", ...props }) => {
	return (
		<CustomTextInput
			muiTextField={PhoneNumberInput}
			// onlyCountries={Object.keys(dataValidation)}
			regions="europe"
			defaultCountry={defaultCountry}
			// isValid={isValid}
			validate={validatePhone}
			// prase doesn't work correct with MaterialUiPhoneNumber
			// parse on server-side
			// parse={parseDigits}
			disableDropdown={false}
			{...props}
		/>
	);
};

// HOC that wraps PhoneInputBase with ownerCompanyData context
export const withOwnerCompanyDefaultCountry = (Component) => {
	return (props) => {
		const { ownerCompanyData } = useOwnerCompanyDataContext();
		const defaultCountry = ownerCompanyData?.base_phone_country_code || "no";

		return <Component {...props} defaultCountry={defaultCountry} />;
	};
};


export const PhoneInput = withOwnerCompanyDefaultCountry(PhoneInputBase);
